import { CascadiaTextProps } from "@certn/cascadia/foundations/typography/types";
import { CascadiaSpacing } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { AriaAttributes, ElementType } from "react";

import { getTextStyle } from "./styles";
import "./Text.css";
import { Skeleton } from "../../patterns/skeleton/Skeleton";
export interface TextProps extends CascadiaTextProps {
  id?: string;
  className?: string;
  align?: "start" | "center" | "end";
  as?: ElementType;
  tabIndex?: string | number;
  dataKey?: string;
  marginTop?: CascadiaSpacing;
  ["aria-live"]?: AriaAttributes["aria-live"];
  skeletonWidth?: number;
}

function getDefaultStyle(component: ElementType) {
  switch (component) {
    case "h1":
      return "global/heading-large";
    case "h2":
      return "form/page-title";
    case "h3":
      return "global/body-secondary";
    case "h4":
      return "input/text-field";
    default:
      return "global/body-secondary";
  }
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function Text(props: TextProps) {
  const {
    id,
    as: Component = "span",
    style = getDefaultStyle(Component),
    children,
    className,
    align,
    color = "text-base",
    tabIndex,
    dataKey,
    testID = "text",
    marginTop,
    truncate,
    isLoading,
    skeletonWidth = 200,
    ...rest
  } = props;

  if (isLoading) {
    return <Skeleton width={skeletonWidth} />;
  }

  return (
    <Component
      data-key={dataKey}
      tabIndex={tabIndex}
      id={id}
      aria-live={rest["aria-live"]}
      className={css([
        {
          color: `var(--${color})`,
          margin: "var(--space-0)",
          padding: "var(--space-0)",
          textAlign: align,
        },
        marginTop && { marginTop: `var(--${marginTop})` },
        getTextStyle(style),
        truncate && {
          overflow: "hidden",
          display: "inline-block",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
        className,
      ])}
      title={truncate && typeof children === "string" ? children : ""}
      data-testid={testID}
    >
      {children}
    </Component>
  );
}
